import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  MAP_PIN_PAGE_ADD_PATH,
  MAP_PIN_PAGE_PATH,
  MAP_PIN_PAGE_SELECT_FLOOR_PATH,
  MAP_PIN_PAGE_UPDATE_PATH,
} from "utils/constants/paths";

const MapPinPage = Loadable(React.lazy(() => import("./View")));
const MapPinPageSelectFloor = Loadable(
  React.lazy(() => import("./View/SelectFloor")),
);
const MapPinPageAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate")),
);

export const MapPinRoute: IRouteItem = {
  path: MAP_PIN_PAGE_PATH,
  element: React.createElement(MapPinPage),
  name: "Map Pins",
  children: [
    {
      name: "Select Floor",
      path: MAP_PIN_PAGE_SELECT_FLOOR_PATH,
      element: React.createElement(MapPinPageSelectFloor),
      showInDrawer: false,
    },
    {
      name: "Add / Update",
      path: MAP_PIN_PAGE_ADD_PATH,
      element: React.createElement(MapPinPageAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: MAP_PIN_PAGE_UPDATE_PATH,
      element: React.createElement(MapPinPageAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
